import React, { Component } from 'react'
import { Link } from 'react-router'

import classNames from './TimelinePeriod.css'
import { emptyQuery, emptyStructure } from '../redux/query'
import { getHash } from '../utils/images'
import { pluralize } from '../utils/string'

const cache = {}

export default class TimelinePeriod extends Component {
  static defaultProps = {
    terms: [],
    path: []
  }
  structure = {
    ...emptyStructure,
    queries: [{
      ...emptyQuery,
      album: this.props.terms.map(value => ({
        value,
        operator: 'must'
      })),
      path: this.props.path.map(value => ({
        value,
        operator: 'must'
      }))
    }]
  }
  hash = getHash(this.structure)
  componentDidMount () {
    const { searchImages, search } = this.props
    const images = search[this.hash]
    if (!images || (!images.data && !images.fetching)) {
      searchImages(this.structure, 0, 65, { simple: true })
    }
  }
  shouldComponentUpdate (nextProps) {
    const { expanded, search } = this.props
    const images = search[this.hash]
    const nextImages = nextProps.search[this.hash]
    if (images && nextImages && !images.data && nextImages.data) {
      return true
    }
    return expanded !== nextProps.expanded
  }
  getThumbLimit (count) {
    if (!count) return 0
    return Math.min(count, 5 + Math.round(Math.log(count) / Math.log(100000) * 60))
  }
  renderThumbs (limit, images) {
    const { getImageSource } = this.props
    let thumbs = []
    for (let i = 0; i !== limit; i++) {
      let style
      const id = images && images[i]
      if (id && !cache[id]) {
        cache[id] = getImageSource(id, 'i')
      }
      if (cache[id]) {
        style = { backgroundImage: `url(${cache[id]})` }
      }
      thumbs.push(
        <div
          key={i}
          className={classNames.thumbnail}
          style={style}
        />
      )
    }
    return thumbs
  }
  render () {
    const { href, title, search, count, expanded, onClickExpand, subevent } = this.props
    const images = search[this.hash] || {}
    const limit = this.getThumbLimit(count)
    const className = subevent ? classNames.subperiod : classNames.period
    return (
      <li className={className}>
        <Link to={href} className={classNames.title}>
          {title}
        </Link>
        {onClickExpand &&
          <button onClick={onClickExpand} className={classNames.expandButton}>
            {expanded ? 'Hide' : 'View'} sub-events
          </button>
        }
        <div className={classNames.count}>
          {pluralize(count, 'image')}
        </div>
        {!expanded &&
          <Link to={href} className={classNames.link}>
            <ul className={classNames.thumbnails}>
              {this.renderThumbs(limit, images.data)}
            </ul>
          </Link>
        }
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TimelinePeriod.js